<aims-side-menu [iconHoverMode]="true" [component]="permissions.ComponentID.Scheduling">
  <ng-template>
    <aims-side-menu-header [displayText]="'Scheduling'">
      <aims-side-menu-link [route]="'./'"
                           [component]="permissions.ComponentID.Scheduler"
                           [iconClass]="'fas fa-tachometer-alt'">
        Scheduler
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./schConfig'"
                           [component]="permissions.ComponentID.SchedulingConfig"
                           [iconClass]="'fas fa-cog'">
        Scheduling Config
      </aims-side-menu-link>

      <aims-side-menu-link [route]="'./siAwaitingApproval'"
                           [component]="permissions.ComponentID.ScheduleApproval"
                           [iconClass]="'fas fa-thumbs-up'">
        SI Awaiting Approval ({{ (count | async)?.schSiApprovals}})
      </aims-side-menu-link>

    </aims-side-menu-header>


    <aims-side-menu-header [displayText]="'Travel'" [collapsible]="true" [defaultOpen]="true">
      <aims-side-menu-link [route]="'./travelDashboard'"
                           [component]="permissions.ComponentID.TravelDashboard"
                           [iconClass]="'fas fa-plane-departure'">
        Dashboard
      </aims-side-menu-link>

      <aims-side-menu-link [route]="'./travelApproval'"
                           [component]="permissions.ComponentID.TravelStep1Approval || permissions.ComponentID.TravelStep2Approval"
                           [iconClass]="'fas fa-thumbs-up'">
        TR Awaiting Approval ({{ (count | async)?.schTrApprovals}})
      </aims-side-menu-link>

      <aims-side-menu-link [route]="'./travelUnconfirmed'"
                           [component]="permissions.ComponentID.TravelUnconfirmed"
                           [iconClass]="'fas fa-thumbs-up'">
        TR Unconfirmed ({{ (count | async)?.schUnconfirmedTravel}})
      </aims-side-menu-link>

      <aims-side-menu-link [route]="'./travelAwaiting'"
                           [component]="permissions.ComponentID.TravelAwaiting"
                           [iconClass]="'fab fa-telegram-plane'">
        Awaiting Arrangements ({{ (count | async)?.schAwaitingTravel}})
      </aims-side-menu-link>

      <aims-side-menu-link [route]="'./schrActionRequired'"
                           [component]="permissions.ComponentID.SchedulerActionRequired"
                           [iconClass]="'far fa-clock'">
        Action Required  ({{ (count | async)?.schSchrActionRequired}})
      </aims-side-menu-link>

      <aims-side-menu-link [route]="'./travelOrphaned'"
                           [component]="permissions.ComponentID.TravelOrphaned"
                           [iconClass]="'fas fa-unlink'">
        Orphaned ({{ (count | async)?.schOrphanedTravel}})
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./travelOpenended'"
                           [component]="permissions.ComponentID.TravelOpenended"
                           [iconClass]="'fas fa-plane'">
        Openended ({{ (count | async)?.schOpenendedTravel}})
      </aims-side-menu-link>

    </aims-side-menu-header>

    <aims-side-menu-header [displayText]="'Scheduling Reports'" [collapsible]="true" [defaultOpen]="true">
      <aims-side-menu-link [route]="'/reporting/BedCountSummary/trdp'"
                           [component]="permissions.ComponentID.Scheduler"
                           [iconClass]="'fas fa-bed'">
        Bed Count
      </aims-side-menu-link>

      <aims-side-menu-link [route]="'/reporting/FlightSummary/trdp'"
                           [component]="permissions.ComponentID.Scheduler"
                           [iconClass]="'fas fa-plane'">
        Flight Summary
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'/reporting/OPS_ScheduleByPerson/trdp'"
                           [component]="permissions.ComponentID.Scheduler"
                           [iconClass]="'fas fa-id-card'">
        OPS Schedule By Person
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'/reporting/MilitaryTravel/trbp'"
                           [component]="permissions.ComponentID.Scheduler"
                           [iconClass]="'far fa-clipboard'">
        Military Travel
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'/reporting/MilitaryTransportAuth/trdp'"
                           [component]="permissions.ComponentID.Scheduler"
                           [iconClass]="'fa fa-suitcase'">
        Military Transport Auth
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'/reporting/EOA_ReturnFromEOA/trdp'"
                           [component]="permissions.ComponentID.Scheduler"
                           [iconClass]="'far fa-calendar-alt'">
        EOA/Return From EOA
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'/reporting/VacationReliefGap/trdp'"
                           [component]="permissions.ComponentID.Scheduler"
                           [iconClass]="'fab fa-megaport'">
        Relief Gaps
      </aims-side-menu-link>

    </aims-side-menu-header>

  </ng-template>
</aims-side-menu>

